<template>
    <v-toolbar
        :class="{ dense: dense }"
        class="stat"
        :max-height="height"
        :height="height"
        :max-width="width"
        :width="width"
    >
        <div class="stat-name" v-html="name"></div>
        <v-spacer></v-spacer>
        <div class="stat-count" v-text="count"></div>
    </v-toolbar>
</template>

<script lang="ts">
    import { defineComponent, reactive, toRefs } from '@vue/composition-api'

    export default defineComponent({
        name: 'Stat',

        props: {
            name: {
                type: String,
                required: true
            },
            count: {
                required: true
            },
            height: {
                type: Number,
                default: 68
            },
            width: {
                type: Number,
                default: 202
            },
            dense: Boolean
        },

        setup(props, context) {
            const state = reactive({})

            return {
                ...toRefs(state)
            }
        }
    })
</script>
